var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level2-container"},_vm._l((_vm.list),function(item,idx){return _c('div',{key:idx,staticClass:"level2-item"},[_c('img',{attrs:{"src":item.icon}}),_c('div',{staticClass:"level2-title"},[_vm._v(_vm._s(item.title)+":")]),_c('div',{staticClass:"level2-count"},[_vm._v(_vm._s(item.count))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }